import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getAddressProvider } from '../services/address'

const useAddressProviderData = (params) => {
  const { idMember, username } = useSelector(state => state)
  const queryKey = useMemo(() => ['useAddressProviderData', idMember, username, params], [idMember, username, params])
  return useQuery({
    queryKey: queryKey,
    queryFn: () => getAddressProvider({ params }),
    staleTime: 1000 * 60 * 15,
    cacheTime: 1000 * 60 * 15,
    retry: 0,
  });
}

export default useAddressProviderData